import {BaseModel} from "../base";

class ReasonModel extends BaseModel {

    constructor(data) {
        super(...arguments);
    }

}

export {
    ReasonModel
}